import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedCompanyCommunicationResidenceTodoApiService } from './company-communication-residence-todo-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyCommunicationResidenceTodoApiService extends GeneratedCompanyCommunicationResidenceTodoApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
